import React, { FunctionComponent } from 'react';
import styles from './Description.module.scss';
import { WPAcfDescriptionBlock } from 'types/acf/description';
import { Block, Typography, BlockContent, EmbedForm } from 'components/elements';
import cx from 'clsx';
import DOMPurify from 'dompurify';
import { FormattedText } from 'components/presentional';

interface OwnProps {
  data: WPAcfDescriptionBlock | null;
  direction?: 'row' | 'column';
  theme?: 'white' | 'light' | 'grey' | 'dark' | 'green';
  align?: 'center' | 'left' | 'right';
  styled?: boolean;
  formId?: string | null;
}

type DescriptionProps = JSX.IntrinsicElements['div'] & OwnProps;

const Description: FunctionComponent<DescriptionProps> = props => {
  const { data, theme = 'white', align = 'center', styled = false, formId } = props;

  if (!data) {
    return null;
  }

  const { description, header } = data;

  if (!description && !header && !formId) {
    return null;
  }

  const containerClassNames = cx({
    [styles.container]: true,
    [styles.styled]: styled,
    [styles[align]]: true,
  });

  const descriptionClassNames = cx({
    [styles.description]: true,
  });

  return (
    <Block id="description" data-module="description" theme={theme}>
      <BlockContent direction="row" className={containerClassNames}>
        <div>
          {header && (
            <Typography mobile="new_neue_semibold_26" tablet="new_neue_semibold_26" desktop="new_neue_32_h1" as="h2" className={styles.header}>
              {header}
            </Typography>
          )}
          {description && <FormattedText className={descriptionClassNames} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }} />}
          {formId && <EmbedForm name="description" className={styles.form} theme="white" formId={formId} />}
        </div>
      </BlockContent>
    </Block>
  );
};

export default Description;
